import { getCityByTerm } from "@/services/localization";
import { useQuery } from "@tanstack/react-query";

export default function useAutocomplete({ term }: { term?: string }) {
  return useQuery({
    queryKey: ["search-city", term],
    enabled: !!term,
    queryFn: () => getCityByTerm(term!),
  });
}
